import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  NotificationResponse,
  UnreadCountResponse,
} from '@libs/core/notification/responses/notification.response';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationHttpClient {
  private readonly baseUrl = environment.api.url;
  private readonly http = inject(HttpClient);

  getNotifications(page = 1, limit = 30): Observable<NotificationResponse> {
    return this.http.get<NotificationResponse>(
      `${this.baseUrl}/notifications`,
      {
        params: {
          page: page.toString(),
          limit: limit.toString(),
        },
      },
    );
  }

  getUnreadCount(): Observable<UnreadCountResponse> {
    return this.http.get<UnreadCountResponse>(
      `${this.baseUrl}/notifications/unread-count`,
    );
  }

  markAsRead(notificationId: string): Observable<void> {
    return this.http.put<void>(
      `${this.baseUrl}/notifications/${notificationId}/read`,
      {},
    );
  }

  markReadByReference(
    referenceId: string,
    sourceType = 'comment',
  ): Observable<void> {
    return this.http.put<void>(
      `${this.baseUrl}/notifications/mark-read-by-reference`,
      { referenceId, sourceType },
    );
  }
}
